export default __webpack_public_path__ + "static/media/27.5594d76b.png";